import React from "react";
import "./AppInstallComponent.scss";
import {connect} from "react-redux";
import {AppState} from "../RootReducer";
import {isAndroid, isBrowser, isFirefox, isIOS} from "react-device-detect";
import {Dispatch} from "redux";
import {setShowIOSGuide} from "../user/UserActions";
import {Settings} from "../http/protocol";
import {PopupAppInstall} from "../contenful/types";
import {t} from "../i18n";
import AppInstallPopUp from "./AppInstallPopUp";
import {isHomeScreen} from "../user/ui/utils";
import {ReactNode} from "react-markdown";
import { getIsGlifeContext } from "../selectors/settings-selectors";

interface Props {
    settings?:Settings;
    showIOSInstallGuide?: typeof setShowIOSGuide;
    popupAppInstall?: PopupAppInstall;
    isGlifeContext?: boolean;
}

interface State {
    show:boolean;
    showGuide:boolean;
}

export function showNativeAppInstallPrompt() {
    if (
      !window.matchMedia("(display-mode: fullscreen)").matches ||
      !window.matchMedia("(display-mode: standalone)").matches
    ) {
      window.installedUsingNativePrompt = "button";
      window.deferredPrompt && window.deferredPrompt.prompt();
    }
}


export class AppInstallComponent extends React.Component<Props, State>{

    constructor(props:Props) {
        super(props);
        if(isHomeScreen()) {
            this.state = {show:false, showGuide: false};
        } else {
            this.state = {show:true, showGuide: false};
        }
    }

    componentDidMount() {
        window.addEventListener("message", (event) => {
            if(event.data == "closePopup") {
                this.setState({showGuide:false})
            }
        })
    }

    showIOSInstall = () => {
        window.installedUsingNativePrompt = 'iosButton';
        this.setState({showGuide:true})
    }
    componentWillUnmount() {
        document.body.style.overflow = "";
    }

    onInstall = () => {
        if(isIOS) {
            this.showIOSInstall();
        } else {
            showNativeAppInstallPrompt();
        }
    };

    onClick = () => {
        this.setState({show:false});
    };

    renderHoverBubble = (device: "android" | "ios" | "windows") => {
        let cf = this.props.popupAppInstall;
        return(
            <div className={"hoverBubble bubblePosition " + (device == "windows" ?  "windows" : "")}>
                <p>{device == "android" && t("app.hover-text.android")}</p>
                <p>{device == "ios" && t("app.hover-text.ios")}</p>
                <p>{device == "windows" && t("app.hover-text.windows")}</p>
            </div>
        )
    }



    render(): ReactNode | ReactNode[]  {
        const settings = this.props.settings;
        const pwaEnabledWindows = settings && settings.pwaEnabledWindows;
        const pwaEnabledIOS = settings && settings.pwaEnabledIOS;
        const pwaEnabledAndroid = settings && settings.pwaEnabledAndroid;
        if(!this.state.show || (this.props.settings && !this.props.settings.pwaEnabled)) {
            // buttons here move to else when done
            return (
                <div></div>
            )
        } else if(this.props.settings && !this.props.settings.appInstallButtonsEnabled) {
            return (
                <div></div>
            )
        } else if (this.props.isGlifeContext) {
            return <div></div>;
        } else {
            return (
                <div className="app-buttons-container">
                    {
                        this.state.showGuide && this.props.settings && <AppInstallPopUp close={()=>this.setState({ showGuide : false })}/>
                    }
                    <div className="download-text-area" onClick={() => this.onInstall()}>Downlaod App</div>
                    {(isBrowser && !isAndroid) && pwaEnabledWindows && window.deferredPrompt &&
                    <button
                        name="windows app download button"
                        aria-label="windows app download button"
                        className="app-button windows"
                        disabled={false}
                        onClick={() => this.onInstall()}
                    >
                        <i className={"device-icon"}><img src={require("../assets/windows.svg").default} /></i>
                        {this.renderHoverBubble("windows")}
                    </button>}
                    {(isIOS || (isBrowser && !isAndroid)) && pwaEnabledIOS &&
                    <button
                        name="apple app download button"
                        aria-label="apple app download button"
                        className="app-button apple"
                        disabled={!isIOS}
                        onClick={() => this.onInstall()}
                    >
                        <i className={"device-icon"}>
                        {AppleIcon}
                        </i>
                        {!isIOS && this.renderHoverBubble("ios")}
                    </button>}
                    {(isAndroid || isBrowser || isFirefox)  && pwaEnabledAndroid && window.deferredPrompt &&
                    <button
                        name="android app download button"
                        aria-label="android app download button"
                        className="app-button android"
                        disabled={!isAndroid}
                        onClick={() => this.onInstall()}
                    >
                        <i className={"device-icon"}><img src={require("../assets/android.svg").default} /></i>
                        {!isAndroid && this.renderHoverBubble("android")}
                    </button>}
                </div>
            )
        }

    }

}

const mapStateToProps = (state : AppState) : Props => (
    {
        settings: state.settings && state.settings.settings,
        popupAppInstall: state.contentful.popupAppInstall,
        isGlifeContext: getIsGlifeContext(state)
    }
)

const mapDispatchToProps = (dispatch : Dispatch) => (
    {
        showIOSInstallGuide : (show:boolean) => dispatch(setShowIOSGuide(show) as any)
    }
)

export default connect(mapStateToProps, mapDispatchToProps)(AppInstallComponent);


const AppleIcon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="4 32 376.4 449.4"  width="20" height="20"><path  d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/></svg>